import React from 'react';
import { CheckCheck, Copy, Download, ImagePlus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

const ActionsSection = ({ copiedUrl, onCopyUrl, onDownload, onAddToGallery, onDelete }) => (
  <div className="space-y-3">
    <h3 className="font-semibold text-sm">Acciones</h3>
    <div className="space-y-2">
      <Button variant="outline" size="sm" onClick={onCopyUrl} className="w-full">
        {copiedUrl ? (
          <>
            <CheckCheck className="w-4 h-4 mr-2" />
            Copiado
          </>
        ) : (
          <>
            <Copy className="w-4 h-4 mr-2" />
            Copiar URL
          </>
        )}
      </Button>
      <Button variant="outline" size="sm" onClick={onDownload} className="w-full">
        <Download className="w-4 h-4 mr-2" />
        Descargar
      </Button>
      <Button variant="outline" size="sm" onClick={onAddToGallery} className="w-full">
        <ImagePlus className="w-4 h-4 mr-2" />
        Cargar a galería
      </Button>
      <Button variant="destructive" size="sm" onClick={onDelete} className="w-full">
        <Trash2 className="w-4 h-4 mr-2" />
        Eliminar
      </Button>
    </div>
  </div>
);

export default ActionsSection;
